<template>
  <IndexPageSection
    v-if="isDisplaySection"
    :link-string="'一覧へ'"
    :link-url="'/items/recent_view'"
    :need-link="needListLink && needLink"
    :section-name="'recent-view-list-section'"
    :title="'最近チェックしたギフト'"
    @click-link="onClickSectionHeaderLink"
  >
    <HorizontalScroll
      ref="recent-view-list-horizontal"
      ref-name="recent-view-list"
    >
      <ItemBoxes
        :items="items"
        :scrollable="false"
        @mount="onMountItemBoxes"
        @click-item-box="onClickItemBox"
      />
    </HorizontalScroll>
  </IndexPageSection>
</template>
<script>
import qs from 'qs'
import IndexPageSection from './IndexPageSection.vue'
import ItemBoxes from '../../../molecules/item_boxes/ItemBoxes.vue'
import axios from 'axios'
import HorizontalScroll from '../../../molecules/horizontal-scrolls/HorizontalScroll.vue'

export default {
  components: { HorizontalScroll, IndexPageSection, ItemBoxes },
  props: {
    needListLink: {
      type: Boolean,
      required: false,
      default: true
    },
    itemLinkBasePath: {
      type: String,
      required: false,
      default: ''
    },
    itemLinkParams: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data() {
    return {
      items: [],
      isItemsLoading: false,
      needLink: false
    }
  },
  computed: {
    isNotItemsEmpty() {
      return this.items.length !== 0
    },
    isDisplaySection() {
      return !this.isItemsLoading && this.isNotItemsEmpty
    }
  },
  mounted() {
    this.getItems()
  },
  methods: {
    onClickItemBox(itemId) {
      this.$emit('click-item-box', itemId)
    },
    onClickSectionHeaderLink() {
      this.$emit('click-section-header-link')
    },
    async getItems() {
      this.isItemsLoading = true
      try {
        const res = await axios.get('/api/v1/pickup/items/recent_view?page=1')
        const { total_pages } = res.data.meta
        this.needLink = total_pages !== 1

        const paramsString = qs.stringify(this.itemLinkParams, {
          arrayFormat: 'brackets'
        })

        this.items = res.data.data
          .map(items => items.attributes)
          .map(item => ({
            id: item.id,
            linkUrl: `${this.itemLinkBasePath}/items/${item.id}?${paramsString}`,
            imageUrl: item.item_box_image_url,
            brandName: item.brand_name,
            itemName: item.name,
            itemPrice: `¥${item.min_price.toLocaleString()}`,
            isIncludingTax: item.is_including_tax,
            hasMultipleItemSkus: item.item_sku_count > 1
          }))
        this.isItemsLoading = false
      } catch (error) {
        this.isItemsLoading = false
        const message =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : '情報の取得に失敗しました。しばらく経ってから再度アクセスしてください'
        this.$emit('error', message)
      }
    },
    onMountItemBoxes() {
      this.$refs['recent-view-list-horizontal'].initializeValues()
    }
  }
}
</script>
